import React from 'react';
import clsx from 'clsx';

import { IconButton } from '@smart-tv/components/icon-button/icon-button';
import PlayerInfoIcon from '@smart-tv/components/icons/info';
import TextIcon from '@smart-tv/components/icons/text';
import testIds from '@smart-tv/e2e/shared/variables';
import { LiveTvChannel } from '@smart-tv/typings/content';

import { PLAYER_FOCUS_KEY_INFO, PLAYER_FOCUS_KEY_SUBTITLE } from '../../player-helpers';
import PausePlayButtons from './pause-play-buttons';
import RecordButton from './record-button';
import ReplayButtons from './replay-buttons';
import { SkipBackward, SkipForward } from './skip-buttons';
import usePlayerControlsNavigation from './use-player-controls-navigation';
import PlayerControlsVolumeControl from './player-controls-volume-control';
import styles from './player-controls-navigation.module.scss';
import { OpenFullscreenIcon } from '@smart-tv/components/icons/open-fullscreen-icon';
import { CloseFullscreenIcon } from '@smart-tv/components/icons/close-fullscreen-icon';
import { IS_BROWSER } from '@smart-tv/utils/is-browser';

export interface Props {
  channel?: LiveTvChannel;
  controlsOpen: boolean;
  closeControls: () => void;
}

export const PlayerControlsNavigation = (props: Props) => {
  const {
    handleOpenProgramInfo,
    // handleOpenChannelList,
    handleOpenSettingsOverlay,
    enableStartOverButton,
    enableRewindButton,
    enableForwardButton,
    setPlayerBtnsFocusHistory,
    isLiveStream,
    toggleFullscreen,
    isDeactivated
  } = usePlayerControlsNavigation(props);

  return (
    <div
      className={clsx(styles['player-controls-navigation'], {
        [styles['player-controls-navigation--deactivated']]: isDeactivated
      })}
    >
      <div className={styles['player-controls-navigation__left']}>
        {enableRewindButton() && <SkipBackward />}

        <PausePlayButtons />

        {enableForwardButton() && <SkipForward />}

        {enableStartOverButton() && <ReplayButtons />}

        {IS_BROWSER && <PlayerControlsVolumeControl />}

        <RecordButton channel={props.channel} />
      </div>

      <div className={styles['player-controls-navigation__right']}>
        {/*
        {IS_BROWSER && isLiveStream && (
          <ToggleChannelListButton classTrigger="push" onClick={handleOpenChannelList} />
        )}
        */}

        <IconButton
          size="xl"
          focusKey={PLAYER_FOCUS_KEY_INFO}
          onClick={() => !isDeactivated && handleOpenProgramInfo()}
          onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_INFO)}
          data-testid={testIds.player.controls.info}
          icon={<PlayerInfoIcon />}
          classTrigger={!IS_BROWSER || !isLiveStream ? 'push' : undefined}
        >
          Info
        </IconButton>
        <IconButton
          size="xl"
          focusKey={PLAYER_FOCUS_KEY_SUBTITLE}
          onClick={() => !isDeactivated && handleOpenSettingsOverlay()}
          onNavFocus={() => setPlayerBtnsFocusHistory(PLAYER_FOCUS_KEY_SUBTITLE)}
          data-testid={testIds.player.controls.settings}
          icon={<TextIcon />}
        >
          Indstillinger
        </IconButton>
        {IS_BROWSER && (
          <IconButton
            size="lg"
            icon={
              document.fullscreenElement == null ? <OpenFullscreenIcon /> : <CloseFullscreenIcon />
            }
            onClick={toggleFullscreen}
            aria-label={document.fullscreenElement == null ? 'Åben fuld skærm' : 'Luk fuld skærm'}
            data-testid={testIds.player.playerControls.fullscreen}
          >
            {document.fullscreenElement == null ? 'Fuld skærm' : 'Afslut fuld skærm'}
          </IconButton>
        )}
      </div>
    </div>
  );
};
